module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-footer-facebook-8405797d58a95d748e6275e53da2af0f.png";